import { render } from "./FacultyStaff.vue?vue&type=template&id=2fe605a2"
import script from "./FacultyStaff.vue?vue&type=script&lang=js"
export * from "./FacultyStaff.vue?vue&type=script&lang=js"

import exportComponent from "/codebuild/output/src4100794178/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__